import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["variant", "quantity", "notice", "submit"]
  static values = {
    availability: Object,
    defaultLabel: String
  }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasQuantityTarget || !this.hasVariantTarget) return

    const quantity = Math.max(parseInt(this.quantityTarget.value, 10) || 1, 1)
    const policy = this.availabilityValue[this.variantTarget.value] || {}
    const available = Math.max(parseInt(policy.stock, 10) || 0, 0)
    const shortage = quantity > available

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = shortage && !policy.shortage_orderable
      this.submitTarget.textContent = shortage && policy.cta_label
        ? policy.cta_label
        : this.defaultLabelValue
    }

    if (!this.hasNoticeTarget) return

    if (!shortage) {
      this.noticeTarget.textContent = ""
      this.noticeTarget.classList.add("hidden")
      return
    }

    this.noticeTarget.textContent = available === 0
      ? policy.unavailable_message
      : policy.partial_message
          .replace("__quantity__", quantity)
          .replace("__available__", available)
    this.noticeTarget.classList.remove("hidden")
  }
}
